import { defineMessages } from 'react-intl'

export default defineMessages({
  save: {
    id: 'containers.UserSettingsPage.components.General.save',
    defaultMessage: 'Save',
  },
  update: {
    id: 'containers.UserSettingsPage.components.General.update',
    defaultMessage: 'Update',
  },
  profile: {
    id: 'containers.UserSettingsPage.components.General.profile',
    defaultMessage: 'Profile',
  },
  visibleInformation: {
    id: 'containers.UserSettingsPage.components.General.visibleInformation',
    defaultMessage: 'This information will be visible to use and your team members.',
  },
  username: {
    id: 'containers.UserSettingsPage.components.General.username',
    defaultMessage: 'Username',
  },
  name: {
    id: 'containers.UserSettingsPage.components.General.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'containers.UserSettingsPage.components.General.email',
    defaultMessage: 'E-mail',
  },
  jobTitle: {
    id: 'containers.UserSettingsPage.components.General.jobTitle',
    defaultMessage: 'Job title',
  },
  photo: {
    id: 'containers.UserSettingsPage.components.General.photo',
    defaultMessage: 'Photo',
  },
  remove: {
    id: 'containers.UserSettingsPage.components.General.remove',
    defaultMessage: 'Remove',
  },
  account: {
    id: 'containers.UserSettingsPage.components.General.account',
    defaultMessage: 'Account',
  },
  manageInformation: {
    id: 'containers.UserSettingsPage.components.General.manageInformation',
    defaultMessage: 'Manage how information is displayed on your account.',
  },
  timezone: {
    id: 'containers.UserSettingsPage.components.General.timezone',
    defaultMessage: 'Time zone',
  },
  language: {
    id: 'containers.UserSettingsPage.components.General.language',
    defaultMessage: 'Language',
  },
})
